'use strict';

import extend from 'lodash/extend';

/**
 * Low-level communication handler for the Type service.
 * Uses Q-based promises for all operations.
 */

(function($) {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};
  window.atex.aceui.service = window.atex.aceui.service || {};

  /**
   * Creates a new TypeService object.
   *
   * @param {string} typeServiceUrl - The URL to the type service in the Content REST API.
   * @param {Object} serviceSettings - An object containing settings for this service.
   * @param {Object} [serviceSettings.customQ = window.Q] - An implementation of Q promises i.e. angular's $q
   *
   * @returns {Object} TypeService - A TypeService
   */
  atex.aceui.service.TypeService = function (typeServiceUrl, serviceSettings) {
    var settings = extend({}, serviceSettings); 
    var q = settings.customQ || window.Q;

    return {
      /**
       * Performs a type lookup in the ACE REST API.
       *
       * @param {Object} transferInfo - An object containing information about the type to lookup.
       * @param {string} transferInfo.typeName - The name of the type to lookup
       * @param {string} transferInfo.authToken - An authentication token to use when communicating with the ACE REST API.
       *
       * @typedef {Object} TypeDefinition - An ace type definition.
       * @typedef {Object} TypeDefinitionResponse - An object containing the result from the TypeService
       * @property {TypeDefinition} typeDefinition
       *
       * @returns {Promise.<TypeDefinitionResponse, atex.aceui.error.Error>}
       */
      getTypeDefinition: function (transferInfo) {
        var deferred = q.defer();

        var fullUrl = typeServiceUrl + '/' + encodeURIComponent(transferInfo.typeName);

        if (settings.cacheBusting === true) {
          fullUrl = fullUrl + '?cacheBusting=' + Math.random().toString().substring(2);
        }

        $.ajax(fullUrl, {
          dataType: 'json',

          beforeSend: function (jqXHR) {
            if (transferInfo.authToken !== undefined) {
              jqXHR.setRequestHeader("X-Auth-Token", transferInfo.authToken);
            }
          },

          success: function (data, textStatus, jqXHR) {
            deferred.resolve({ typeDefinition: data });
          },

          error: function (jqXHR, textStatus, errorThrown) {
            var e = atex.aceui.HTTPUtils.createError(jqXHR, 'atex.aceui.service.TypeService', {
              401: 'Could not authenticate user while getting type "' + transferInfo.typeName + '" from the server',
              403: 'Permission denied when getting "' + transferInfo.typeName + '" from the server',
              404: 'Type "' + transferInfo.typeName + '" was not found on the server (404)',
              'default': 'There was an error while getting type "' + transferInfo.typeName + '" from the server'
            });

            e.transferInfo = transferInfo;

            deferred.reject(e);
          }
        });

        return deferred.promise;
      }
    };
  };
})(jQuery);
